module.exports = __webpack_public_path__ + "img/slide_multidispositivo.f4e14a6b.jpg";